import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid } from '@material-ui/core';
import MateService from '../../../../services/MateService/MateService';
import DataTable from '../../../../components/DataTable/DataTable';
import DeleteConfirm from '../../../../components/DataTable/DeleteConfirm';
import Search from "../../../../components/Search/Search";
import CustomizeView from "../../../../components/DataTable/CustomizeView/CustomizeView";
import Filters from '../../../../components/DataTable/Filters/Filters';
import MateDetail from "../mateDetail/MateDetail";
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { alertState, personalizationState } from '../../../../recoil-store/recoil-state';
import { convertToDateFormat } from '../../../../helpers/helper';

let deletedMates = [];
let setSelectedMateRow;

function MatesList(props) {
    const { t } = useTranslation();
    const personalization = useRecoilValue(personalizationState);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [searchData, setSearchData] = useState([])
    const [customColumn, setCustomColumn] = useState([])
    const [showDetail, setShowDetail] = useState(false)
    const [activeId, setActiveId] = useState("")
    const [openFilters, setOpenFilters] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
    const setAlert = useSetRecoilState(alertState)

    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        setLoading(true);
        let response = await MateService.getAllMates();
        if (response) {
            setData(response.data);
            setSearchData(response.data);
        }
        setLoading(false);
    }

    const handleRowSelect = async () => {
        if (selectedRowIndex >= 0) {
            let rowData = data[selectedRowIndex];
            const response = await MateService.postDefault(rowData.id);
            if (response) {
                if (response?.status === true) {
                    fetchData();
                }
            }
        }

    }
    const handleRowsDelete = (rowsDeleted, dataArray, setSelectedRows) => {
        setOpenDelete(true)
        deletedMates = [];
        for (let i of rowsDeleted.data) {
            deletedMates.push(searchData[i.dataIndex].id);
        }
        setSelectedMateRow = setSelectedRows;
    };

    const deleteMates = async () => {
        setLoadingDelete(true);
        const response = await MateService.deleteMates(deletedMates);
        if (response) {
            setAlert(alert => ({ ...alert, show: true, message: t(`CONTENT.MYMATES.${response.message}`), severity: response.status ? 'success' : 'error' }))
            if (response.status) {
                fetchData();
            }
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        setSelectedMateRow([])
        setLoadingDelete(false);
    };

    function handleOpen(open, setState) {
        setState(!open)
    }

    function downloadMateAgent() {
        window.open("/source/mate_agent.exe", '_blank').focus();
    }

    useEffect(() => {
        const column = [{
            id: 0,
            name: "id",
            label: " ",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (searchData && searchData[dataIndex]) {
                        return <span>{dataIndex + 1}.</span>;
                    }
                },
            },
        }, {
            id: 1,
            name: 'status',
            label: t('CONTENT.MYMATES.STATUS'),
            options: {
                filter: true, sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (searchData[dataIndex]) {
                        return (
                            <span className="status-success">
                                {searchData[dataIndex].status}
                            </span>
                        );
                    }
                }
            }
        }, {
            id: 2,
            name: 'device_name',
            label: t('CONTENT.MYMATES.DEVICE_NAME'),
            options: {
                filter: true, sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (searchData[dataIndex]) {
                        return (
                            <span className="link-text" onClick={() => {
                                setActiveId(searchData[dataIndex]?.id);
                                setShowDetail(true);
                            }
                            }>
                                {searchData[dataIndex].device_name}
                            </span>
                        );
                    }
                }
            }
        }, {
            id: 3,
            name: 'device_user',
            label: t('CONTENT.MYMATES.AGENT_USER'),
            options: { filter: true, sort: true }
        }, {
            id: 4,
            name: 'agent_version',
            label: t('CONTENT.MYMATES.AGENT_VERSION'),
            options: { filter: true, sort: true, display: false }
        }, {
            id: 5,
            name: 'is_default_device',
            label: t('CONTENT.MYMATES.DEFAULT_DEVICE'),
            options: { filter: true, sort: true }
        }, {
            id: 6,
            name: 'is_local_device',
            label: t('CONTENT.MYMATES.LOCAL_DEVICE'),
            options: { filter: true, sort: true }
        }, {
            id: 7,
            name: 'created_at',
            label: t('CONTENT.MYMATES.CREATED_AT'),
            options: {
                filter: true, sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (searchData[dataIndex]) {
                        return convertToDateFormat(searchData[dataIndex]?.created_at, personalization.date_format);
                    }
                }
            }
        }]
        setCustomColumn(column);
    }, [searchData])

    return (
        <div id="mateslist-container" style={{ width: '100%' }}>
            <Search data={data} setSearchData={setSearchData} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}
                searchKey={["status", "device_user", "created_at", "device_name", "is_local_device", "is_default_device"]}>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Button className="searchbar-button"
                        onClick={() => {
                            setActiveId(null);
                            downloadMateAgent();
                        }}
                    >{t('CONTENT.MYMATES.DOWNLOAD-MATE')}</Button>

                    <Button className="searchbar-button"
                        onClick={() => handleOpen(openCustomizeView, setOpenCustomizeView)}>{t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}</Button>
                    <Button className="searchbar-button"
                        onClick={() => handleOpen(openFilters, setOpenFilters)}>{t('CONTENT.DATATABLE.TOOLBAR.FILTERS')}</Button>
                    <Button className="searchbar-button"
                        onClick={() => handleRowSelect()}>{t('CONTENT.DATATABLE.TOOLBAR.MAKE-DEFAULT')}</Button>
                </Grid>
            </Search>
            <DataTable
                data-test="mymates-datatable"
                // customToolbar={customToolbar}
                customColumns={customColumn}
                onRowsDelete={handleRowsDelete}
                setSelectedRowIndex={setSelectedRowIndex}
                selectedRowIndex={true}
                selectableRows="multiple"
                data={searchData}
                title={t('CONTENT.MYMATES.MY_MATES')}
                loading={loading}
                loadingDelete={loadingDelete}
            />
            {openDelete && <DeleteConfirm setOpenDelete={setOpenDelete} message={t('CONTENT.MYMATES.DELETE-WARNING')}
                deleteFunc={deleteMates} />}
            {openCustomizeView && <CustomizeView setOpen={setOpenCustomizeView} customColumn={customColumn}
                setCustomColumn={setCustomColumn} />}
            {
                showDetail && <MateDetail setShowDetail={setShowDetail} id={activeId} />
            }
            {openFilters &&
                <Filters setOpen={setOpenFilters} customColumn={customColumn} setCustomColumn={setCustomColumn} />}
        </div>
    );
}

export default MatesList;
